import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import './RateTable.css';
import GuestModel from './GuestModel';
import apiService from '../api/apiService';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Pagination from './Pagination/Pagination';
import ConfirmDeleteModal from './ConfirmDeleteModal';

const Table = ({ data, setData, hotelId }) => {
  const [bookings, setBookings] = useState([]);
  const [editingItem, setEditingItem] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState({
    isOpen: false,
    id: null,
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(5);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = Array.isArray(data)
    ? data.slice(indexOfFirstRow, indexOfLastRow)
    : [];
  const totalPages = Math.max(Math.ceil(data.length / rowsPerPage), 1);

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const response = await apiService.get('/bookings/');
        setBookings(response);
      } catch (error) {
        console.error('Failed to fetch bookings:', error);
      }
    };

    fetchBookings();
  }, []);

  const handleEditClick = item => {
    setEditingItem(item);
    setIsModalOpen(true);
  };

  const handleEdit = updatedItem => {
    if (!updatedItem || !updatedItem.id) return;
    setData(prevData =>
      prevData.map(item =>
        item.id === updatedItem.id ? { ...item, ...updatedItem } : item
      )
    );
    setIsModalOpen(false);
    setEditingItem(null);
  };

  const confirmDelete = id => {
    if (!id) return;
    setDeleteConfirm({ isOpen: true, id });
  };

  const handleDelete = async () => {
    try {
      await apiService.patch(`/guests/${deleteConfirm.id}/?${hotelId}`, {
        is_archive: true,
      });
      toast.error('Guest deleted successfully!');
      setData(prevData =>
        prevData.filter(item => item.id !== deleteConfirm.id)
      );
    } catch (err) {
      toast.error('Failed to delete! Please try again.');
    } finally {
      setDeleteConfirm({ isOpen: false, id: null });
    }
  };

  return (
    <>
      <div className="rate-table-container" style={{ minHeight: '300px' }}>
        <table className="rate-table">
          <thead>
            <tr>
              <th>Guest Name</th>
              <th>Room Numbers</th> {/* new column */}
              <th>Phone Number</th>
              <th>Address</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(currentRows) && currentRows.length > 0 ? (
              currentRows.map(item =>
                item && item.id ? (
                  <tr key={item.id}>
                    <td>{item.name || 'N/A'}</td>
                    <td>
                      {bookings
                        .filter(booking => booking.guest === item.id)
                        .flatMap(booking => booking.room || [])
                        .map(room => room.room_number)
                        .join(', ') || 'N/A'}
                    </td>
                    <td>{`+ ${item.phone}` || 'N/A'}</td>
                    <td>{item.address || 'N/A'}</td>

                    <td>
                      <div className="options-menu">
                        <button className="options-button">⋮</button>
                        <div className="dropdown-menu">
                          <button onClick={() => handleEditClick(item)}>
                            Edit
                          </button>
                          <button onClick={() => confirmDelete(item.id)}>
                            Delete
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                ) : null
              )
            ) : (
              <tr>
                <td colSpan="5">No data available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {isModalOpen && (
        <GuestModel
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSave={handleEdit}
          existingData={editingItem}
          hotelId={hotelId}
        />
      )}

      {deleteConfirm.isOpen && (
        <ConfirmDeleteModal
          isOpen={deleteConfirm.isOpen}
          onConfirm={handleDelete}
          onCancel={() => setDeleteConfirm({ isOpen: false, id: null })}
          message="Are you sure you want to delete this guest?"
        />
      )}

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
      />
    </>
  );
};

export default Table;
